import { render, staticRenderFns } from "./teamMembers.vue?vue&type=template&id=d7b425e2"
import script from "./teamMembers.vue?vue&type=script&lang=js"
export * from "./teamMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports